import { forwardRef } from 'react';

export const Sentinel = forwardRef(
	({ position }: { position: 'top' | 'bottom' }, ref: React.Ref<HTMLDivElement>) => (
		// eslint-disable-next-line react/forbid-elements
		<div
			ref={ref}
			style={{
				position: 'absolute',
				top: position === 'top' ? 0 : undefined,
				bottom: position === 'bottom' ? 0 : undefined,
				left: 0,
				right: 0,
				pointerEvents: 'none',
				// To debug uncomment
				// height: 10,
				// zIndex: 1000,
				// border: '1px dashed red',
				// backgroundColor: 'rgba(255, 0, 0, 0.1)',
			}}
		/>
	)
);
